import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { Message } from './services/messages.service';

@Component({
    selector: 'app-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss']
})
export class MessageComponent {
    private _despawning: boolean = false;
    private _currAnimation?: Animation;
    private _died: boolean = false;

    public get isDespawning() {
        return this._despawning;
    }

    public get hasDied() {
        return this._died;
    }

    @Input('message')
    public message!: Message;

    @Input('isDespawning')
    public set isDespawning(val) {
        this._despawning = val;
        if (val) {
            this._currAnimation = this.ref.nativeElement.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                easing: 'ease-out',
                duration: 500,
            });
            this._currAnimation!.onfinish = () => {
                this._died = true;
                this.ref.nativeElement.style.display = 'none';
                this.despawned.next();
            };
        }
        else {
            this._currAnimation?.cancel();
        }
    }

    @Output('despawned')
    public despawned = new EventEmitter<void>();

    public constructor(
        private ref: ElementRef
    ) { }
}
